// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
// import FastClick from 'fastclick'

import "./vux";
import App from "./App";
import router from "@/router";
import store from "./store";
import createIcon from "@/components/Icon";
import "@/router/permission";
import AMap from "vue-amap";
import "./styles/global.less";
import VueCompositionAPI from "@vue/composition-api";
import Validator from "validatorjs";
import "validatorjs/dist/lang/zh";
import "@/utils/filters";
import permission from "@/utils/helper/permission";
import { get } from "@/utils/lodash";
import { ValidatorPlugin } from "@/utils/validator";

import { isWechatBrowser } from "@/utils/wx-utils";
import VueBus from "vue-bus";
import hooks from "@u3u/vue-hooks";

import "viewerjs/dist/viewer.css";
import Viewer from "v-viewer";
import VueJsonp from "vue-jsonp";
import check from "./api/check.js";
import Navigation from "vue-navigation";
import Vant from 'vant';
import 'vant/lib/index.css';

// import { DropdownMenu, DropdownItem } from "vant";
// import { RadioGroup, Radio } from "vant";
// import { Button } from "vant";
// import { Field } from "vant";
// import { Overlay } from "vant";
// import { List } from "vant";
//
// import { Checkbox, CheckboxGroup } from "vant";

Vue.use(Navigation, { router, store });

Vue.use(VueJsonp);
Vue.use(Viewer);

Vue.use(hooks);
Vue.use(VueBus);
Vue.use(ValidatorPlugin);
Vue.use(permission);
// Vue.use(List);
// Vue.use(DropdownMenu);
// Vue.use(DropdownItem);
// Vue.use(Radio);
// Vue.use(RadioGroup);
// Vue.use(Button);
// Vue.use(Field);
// Vue.use(Overlay);
Vue.use(Vant);

Vue.prototype.$get = get;
// Vue.use(Checkbox);
// Vue.use(CheckboxGroup);
Vue.use(VueCompositionAPI);
Validator.useLang("zh");

Vue.prototype.$isWechat = isWechatBrowser();

AMap.initAMapApiLoader({
  key: "0a234e764d76d27e3c9175e867f4b71a",
  plugin: [
    "AMap.Geolocation",
    "AMap.Autocomplete",
    "AMap.PlaceSearch",
    "AMap.Scale",
    "AMap.OverView",
    "AMap.ToolBar",
    "AMap.MapType",
    "AMap.PolyEditor",
    "AMap.CircleEditor"
  ],
  v: "1.4.4"
});

const amapKeys = Object.keys(localStorage).filter(key => key.match(/^_AMap_/));

amapKeys.forEach(key => {
  // console.log(key)
  localStorage.removeItem(key);
});
Vue.use(AMap);

// const Icon = createIcon('//at.alicdn.com/t/font_1236734_7dujq5rb87e.js')
const Icon = createIcon("//at.alicdn.com/t/font_1584033_f71bsn328lb.js");

Vue.component("Icon", Icon);
Vue.prototype.check = check;

Vue.use({
  install(v) {
    (v.prototype.$showMessage = function(message) {
      this.$vux.toast.text(message);
    }),
      (v.prototype.$showError = function(err, type) {
        if (type) {
          this.$vux.toast.show({
            text: err,
            type
          });
        } else {
          this.$vux.toast.text(err);
        }
      });
  }
});

// FastClick.attach(document.body)

Vue.config.productionTip = false;

store.dispatch("init");

/* eslint-disable no-new */
// export default new Vue({
//   router,
//   store,
//   render: h => h(App)
// }).$mount("#app-box");

function isApp() {
  let ua = navigator.userAgent.toLowerCase();
  if (ua.indexOf("hsx_") > 0) {
    initJsBridge(function() {
      let storage = window.localStorage;
      storage.clear();
      initVueApp();
      router.replace({ path: "/overPage" });
    });
  } else {
    initVueApp();
  }
  // if (ua.match(/MicroMessenger/i) == "micromessenger") {
  //   // console.log("这是微信打开的");
  //   initVueApp();
  // } else {
  //   // console.log("这是APP打开的");
  //   initJsBridge(function() {
  //     let storage = window.localStorage;
  //     storage.clear();
  //     initVueApp();
  //     router.replace({ path: "/overPage" });
  //   });
  // }
}

isApp();

function initVueApp() {
  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount("#app-box");
}

function initJsBridge(readyCallback) {
  let u = navigator.userAgent;
  let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; // android终端
  let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); // ios终端
  // console.log("isAndroid：" + isAndroid);
  // console.log("isiOS：" + isiOS);

  // 注册jsbridge
  function connectWebViewJavascriptBridge(callback) {
    if (isAndroid) {
      if (window.WebViewJavascriptBridge) {
        callback(window.WebViewJavascriptBridge);
      } else {
        document.addEventListener(
          "WebViewJavascriptBridgeReady",
          function() {
            callback(window.WebViewJavascriptBridge);
          },
          false
        );
      }
      return;
    }
    if (isiOS) {
      if (window.WebViewJavascriptBridge) {
        return callback(window.WebViewJavascriptBridge);
      }
      if (window.WVJBCallbacks) {
        return window.WVJBCallbacks.push(callback);
      }
      window.WVJBCallbacks = [callback];
      var WVJBIframe = document.createElement("iframe");
      WVJBIframe.style.display = "none";
      WVJBIframe.src = "https://__bridge_loaded__";
      document.documentElement.appendChild(WVJBIframe);
      setTimeout(function() {
        document.documentElement.removeChild(WVJBIframe);
      }, 0);
    }
  }

  // 调用注册方法
  connectWebViewJavascriptBridge(function(bridge) {
    if (isAndroid) {
      bridge.init(function(message, responseCallback) {
        // console.log("JS got a message", message);
        responseCallback();
      });
    }
    readyCallback(bridge);
  });
}
